<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="overview">
    <div class="row" v-for="(row, rowIndex) in showData" :key="rowIndex">
      <div class="name-group grid">
        <div class="name" v-for="(item, index) in row" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="value-group grid">
        <div class="value" v-for="(item, index) in row" :key="index">
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';

const showData = computed(() => {
  const tableData = getOverviewData(_testOverviewData, false, false, false);
  return tableData.reduce(
    (pre, cur) => {
      const last = pre.slice(-1)[0];
      if (Array.isArray(last) && last?.length < 3) {
        pre.slice(-1)[0]?.push(cur);
      } else {
        pre.push([cur]);
      }
      return pre;
    },
    [[]] as Array<typeof tableData>
  );
});
</script>
<style lang="scss" scoped>
@import './index.scss';
.row {
  margin: 0 100px;
  font-size: 16px;
  border-left: 1px solid #dbdbdb;
  line-height: 1.3;
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .name {
    padding: 27px 20px;
    background-color: var(--theme-color-1);
    color: #fff;
    display: flex;
    align-items: center;
    border-right: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
  }
  .value {
    padding: 24px 20px;
    color: #2b2b2b;
    display: flex;
    align-items: center;
    border-right: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
  }
}
</style>
